import React from 'react'
import styled from 'styled-components'
import { useEthers } from '../../hooks'
import { ChainId, Colors, PAIRS_BY_CHAIN } from '../../constants'
import { Currency } from '../../model'
import { Modal } from '../Modal'
import { PairSelectItem } from './PairSelectItem'

interface Props {
  onClose: () => void
  onChange: (currency: Currency, other: Currency) => void
}

export function PairSelectModal({ onChange, onClose }: Props) {
  const { chainId = ChainId.Mainnet } = useEthers()
  const pairs = PAIRS_BY_CHAIN[chainId]

  return (
    <Modal title="Select a Pair" onClose={onClose}>
      <List>
        {pairs.map((pair, i) => (
          <ListItem key={i}>
            <PairSelectItem pair={pair} onClick={() => onChange(pair.tokens[0], pair.tokens[1])} />
          </ListItem>
        ))}
      </List>
    </Modal>
  )
}

const List = styled.ul`
  margin: 0;
  padding: 15px 0;
  list-style: none;
`

const ListItem = styled.li`
  padding: 0 20px;
  position: relative;

  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 20px;
    width: calc(100% - 40px);
    height: 1px;
    background-color: ${Colors.LighterGray};
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`
